import { useChannelTalk } from '@repo/channel-talk';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import CorporationSelectJointCertificateContent from '@/components/tax-refund/corporation/SelectJointCertificate/CorporationSelectJointCertificateContent';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const CorporationSelectJointCertificatePage = () => {
  const router = useRouter();
  const { openChannelTalk } = useChannelTalk();

  const handleClickRight = () => {
    openChannelTalk(SUPPORT_BOT_LINK.인증정보입력);
  };

  return (
    <AuthGuard>
      <Layout
        leftIcon={{ icon: 'back', onClick: router.back }}
        rightTextButton={{
          label: '문의하기',
          state: 'gray',
          onClick: handleClickRight
        }}
      >
        <CorporationSelectJointCertificateContent />
      </Layout>
    </AuthGuard>
  );
};

export default CorporationSelectJointCertificatePage;
